/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import "../styles/MetalDetails.css";
import TradingViewWidget from "./TradingViewWidget";
function MetalDetails() {
  const queryParameters = new URLSearchParams(window.location.search)
  // const currencies = ['GBP','USD','EUR','SGD','AUD','CHF','JPY'] 
  // const nonExistingChart = ['XPTSGD','XPTAUD','XPTCHF','XPDSGD','XPDAUD','XPDCHF']
  console.log(queryParameters.get("metal"))
  const [chartType] = useState(queryParameters.get("chartType") ?? 'candles')
  const [selectedMetal] = useState(queryParameters.get("metal") ?? 'XAU')
  const [selectedCurrency] = useState(queryParameters.get("currency") ?? 'GBP')
  
  return (
    <div className="App">
      <div className="App-container">
            <div className="container"  >
                        <div className="card shadow"  style={{height: '100vh' , width: '100vw' }}>
                            <div className="card-body">
                                <TradingViewWidget chartType={chartType} currency={selectedCurrency} metal={selectedMetal}></TradingViewWidget>
                            </div>
                    </div>
                </div>
            </div>
        </div>
  );
}
export default MetalDetails;